import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSnackbar } from 'notistack';
import usersService from '../../services/users';
import './Password.css';
// @ts-ignore
import background from './password_background.jpg';
import TextField from '../TextField/TextField';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { Email } from '@material-ui/icons';
import logo from '../Login/scisports-logo.svg';

const Wrapper = styled.div`
  width: 479px;
  height: 100%;
  overflow: hidden;
`;

const Semitransparent = styled.div`
  height: 100%;
  width: 500px;
  background: url(${background}) no-repeat center center fixed;
  filter: blur(10px);
  top: 0px;
  left: -100px;
  right: -100px;
  overflow: hidden;
  background-size: cover;
`;

const PasswordWrapper = styled.div`
  height: 100%;
`;

const PasswordDialog = styled.div`
  position: absolute;
  width: 461px;
  height: 595px;
  left: 160px;
  top: calc(50% - 300px);
  background-color: white;
`;


const InmotioLogo = styled.img`
  width: 400px;
  height: 120px;
  padding-top: 39px;
  padding-left: 60px;
`;

const EmailField = styled(TextField)`
  margin: auto;
`;

const PasswordButtonWrapper = styled.div`
  width: 370px;
  margin: auto;
  margin-top: 63px;
`;

const PasswordTextWrapper = styled.div`
  width: 370px;
  margin: auto;
  margin-top: 32px;
`;

interface Props {
  history: any;
}

const Invite = (props: Props) => {
  let [email, setEmail] = useState('');
  let [firstname, setFirstname] = useState('');
  let [lastname, setLastname] = useState('');
  const { enqueueSnackbar } = useSnackbar();

  const onSend = () => {
    usersService.createUser({ email, firstName: firstname, lastName: lastname, account: 'balljames', roles: [] }).then(
      () => {
        props.history.push('/sessions');
      },
      () => enqueueSnackbar('Failed to invite user', { variant: 'error', autoHideDuration: 3000 })
    );
  };

  useEffect(() => {
    document.body.classList.add('login-body');
    return () => {
      document.body.classList.remove('login-body');
    };
  });

  return (
    <PasswordWrapper>
      <Wrapper>
        <Semitransparent />
      </Wrapper>
      <PasswordDialog>
        <InmotioLogo src={logo} />
        <PasswordTextWrapper>
          Please enter the email address, firstname and lastname of the person you want to invite
        </PasswordTextWrapper>
        <EmailField
          id="email"
          placeholder="Email"
          label="Email"
          value={email}
          width={370}
          onChange={(event) => setEmail(event.target.value)}
          inputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton>
                  <Email />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <PasswordTextWrapper>
          <TextField
            id="firstname"
            placeholder="Firstname"
            value={firstname}
            onChange={(event) => setFirstname(event.target.value)}
          />
          <TextField
            id="lastname"
            placeholder="Lastname"
            value={lastname}
            onChange={(event) => setLastname(event.target.value)}
          />
        </PasswordTextWrapper>

        <PasswordButtonWrapper>
          <Button size="large" variant="contained" color="primary" fullWidth onClick={onSend}>
            Send invite
          </Button>
        </PasswordButtonWrapper>
      </PasswordDialog>
    </PasswordWrapper>
  );
};

export default Invite;
